import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'accountingLRFund';
  admin_data: any


  constructor(
    public router :Router
  ) { }

  ngOnInit(): void {
    this.admin_data = localStorage.getItem("admin_data");
    this.admin_data = JSON.parse(this.admin_data);
  }
  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
  async onClickListMenu() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
}

